// extracted by mini-css-extract-plugin
module.exports = {"button":"social-button_button__vPITI","iconBox":"social-button_iconBox__5zYDj","text":"social-button_text__C_Sl8"};